module.exports = __webpack_public_path__ + "components/flag/static/square/ec-d872b6d7772c66611e31c2bcd3169df5.svg";